@if (loading().amount) {
  <div class="mt-d text-right">{{ 'app.lib.common.loading' | actrans }}...</div>
} @else if (!isOrderable()) {
  <nz-alert class="mt-d" nzType="warning" nzShowIcon
    [nzMessage]="'web.servlet.json.updatePrice.notAvailable' | actrans | str">
  </nz-alert>
} @else if (amount()) {
  <div class="bt-table">
    <table>
      <tbody>
        @if (hasDiscount()) {
          <tr>
            <td>{{ 'common.amount' | actrans }}</td>
            <td class="text-right" [style.width]="'50%'">
              <span class="text-line-through fgc-red">{{ amount()!.retailAmount | nf }}</span>
            </td>
          </tr>
          <tr>
            <td class="fgc-green">{{ 'common.discount' | actrans }}</td>
            <td class="text-right fgc-green" [style.width]="'50%'">
              {{ discountAmount() | nf }}
            </td>
          </tr>
        }
        <tr class="ci-total-row">
          <td class="btt-label">{{ 'common.total' | actrans }}</td>
          <td class="text-right text-bold" [style.width]="'50%'">
            {{ totalAmount() | nf }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
}
